import {BaseDataBuilder, PrimitiveDataTypes} from './BaseDataBuilder'
import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
//@ts-expect-error Expect error on @types as package builded with js
import jsonSchemaUtils from '@wix/wix-json-schema-utils'
import type {Builder} from '@wix/document-services-types'

export class ObjectBuilder extends BaseDataBuilder {
    constructor(displayName: string, defaultValue: any, private properties?: Record<string, any>) {
        super('object', displayName, defaultValue)
    }

    propertiesToBuilder(): Record<string, {type: PrimitiveDataTypes}> {
        if (!this.properties) {
            return {}
        }
        return Object.entries(this.properties).reduce((acc, [key, value]) => {
            const resolver = jsonSchemaUtils.createResolver(jsonSchemaUtils.baseDefinitions)
            const resolvedSchema = resolver.resolve(value)
            return {
                ...acc,
                [key]: {
                    type: resolvedSchema.type
                }
            }
        }, {})
    }

    toBuilderDataItem(): Builder.DataItem {
        return {
            displayName: this.displayName,
            dataType: DATA.DATA_TYPE.schema,
            defaultValue: this.defaultValue,
            [DATA.DATA_TYPE.schema]: {
                type: 'object',
                properties: this.propertiesToBuilder()
            }
        }
    }
}
